
export const imageData = [
    { id: 0, src: '/assets/images/sIconUp.png', passSrc: '/assets/images/Thankyou1_4.png' },
    { id: 1, src: '/assets/images/sIconB.png', passSrc: '/assets/images/Thankyou1_4.png' },
    { id: 2, src: '/assets/images/sIconL.png', passSrc: '/assets/images/Thankyou1_4.png' },
    { id: 3, src: '/assets/images/sIconR.png', passSrc: '/assets/images/Thankyou1_4.png' },

    { id: 4, src: '/assets/images/sIconCircleUp.png', passSrc: '/assets/images/ThankYou4_7.png' },
    { id: 5, src: '/assets/images/sIconCircleB.png', passSrc: '/assets/images/ThankYou4_7.png' },
    { id: 6, src: '/assets/images/sIconCircleL.png', passSrc: '/assets/images/ThankYou4_7.png' },
    { id: 7, src: '/assets/images/sIconCircleR.png', passSrc: '/assets/images/ThankYou4_7.png' },

    { id: 8, src: '/assets/images/mediumTop.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 9, src: '/assets/images/mediumDown.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 10, src: '/assets/images/mediumRight.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 11, src: '/assets/images/mediumLeft.png', passSrc: '/assets/images/Thank.svg.webp' },

    { id: 12, src: '/assets/images/centerRect.png', passSrc: '' },
    { id: 13, src: '/assets/images/centerSqr.png', passSrc: '' },
    { id: 14, src: '/assets/images/bigCenter.png', passSrc: '' },

    { id: 15, src: '/assets/images/smallRight.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 16, src: '/assets/images/smallLeft.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 17, src: '/assets/images/smallDown.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 18, src: '/assets/images/smallTop.png', passSrc: '/assets/images/Thank.svg.webp' },

    { id: 19, src: '/assets/images/bigDown.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 20, src: '/assets/images/bigUp.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 21, src: '/assets/images/bigLeft.png', passSrc: '/assets/images/Thank.svg.webp' },
    { id: 22, src: '/assets/images/bigRight.png', passSrc: '/assets/images/Thank.svg.webp' },

    { id: 23, src: '/assets/images/none.png', passSrc: '' },
]